import React from "react";
import PageContainer from "../../../components/container/Container";
import WhatWeOffer from "../../../components/services/WhatWeOffer";
import { kubernetWhatWeOffer } from "../../../data/servicesOffered";
import HowItWorks from "../../../components/services/HowItWorks";
import { kubernetHowItWorkData } from "../../../data/howServiceWorks";
import ExclusiveFeatures from "../../../components/services/ExclusiveFeatures";
import { kubernetFeaturesData } from "../../../data/exclusiveFeatures";
import bg1 from "../../../assets/images/Banner_imgs/services_3.jpg";

function kubernetes_adoption() {
  return (
    <PageContainer 
      title="Data AI/ML Solutions - CodeElan Technologies" 
      description="Harness the power of Data, Artificial Intelligence, and Machine Learning to drive innovation, efficiency, and intelligent decision-making for your business."
    >
      {/* Hero Section */}
      <section className="hero-section contact-hero">
        <div className="hero-background">
          <div className="hero-overlay"></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-8 mx-auto text-center">
                <div className="hero-content">
                  <div className="hero-accent"></div>
                  <h1 className="hero-title">
                    <span className="text-primary">Data AI/ML</span> Solutions
                  </h1>
                  <p className="hero-subtitle">
                    In today's data-driven world, businesses must harness the power of Data, Artificial Intelligence (AI), and Machine Learning (ML) to drive innovation, efficiency, and decision-making.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Service Description */}
      <section className="section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="service-description">
                <p className="service-text">
                  Our expertise in AI and ML enables organizations to extract meaningful insights, automate processes, and build intelligent systems tailored to their unique needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What We Offer */}
      <WhatWeOffer data={kubernetWhatWeOffer} />

      {/* How It Works */}
      <HowItWorks data={kubernetHowItWorkData} />

      {/* Exclusive Features */}
      <ExclusiveFeatures data={kubernetFeaturesData} />
    </PageContainer>
  );
}

export default kubernetes_adoption;
